export default [
  {
    code: 'id',
    name: 'id',
    type: 'id',
  },
  {
    code: 'shortName',
    name: 'short_name',
    type: 'input',
  },
  {
    code: 'fullName',
    name: 'full_name',
    type: 'input',
  },
  {
    code: 'status',
    name: 'status',
    type: 'select',
    dictionary: 'goodsstatus',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'description',
    name: 'description',
    type: 'input',
  },
  {
    code: 'employer',
    name: 'employer',
    type: 'select',
    dictionary: 'organization',
    itemValue: 'id',
    itemText: 'shortName',
  },
  {
    code: 'group',
    name: 'group',
    type: 'select',
    dictionary: 'goodsgroup',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'articleNumber',
    name: 'article_number',
    type: 'input',
  },
]
